import { initContract } from '@ts-rest/core'
import z from 'zod'
import { DeleteMigratedUserEventsRequestSchema, DeleteMigratedUserEventsResponseSchema, GetUserEventPathParamSchema, GetUserEventQuerySchema, GetUserEventResponseSchema, MigrateUserEventsRequestSchema, MigrateUserEventsResponseSchema, VerifyUserEventsRequestSchema, VerifyUserEventsResponseSchema } from './schemas'

const c = initContract()

export const userEventServiceContract = c.router({
  getHealth: {
    method: 'GET',
    path: '/health',
    summary: 'Health check endpoint',
    description: 'Checks if the service is healthy',
    responses: {
      200: z.object({
        status: z.string(),
      }),
    },
  },

  getUserEvents: {
    method: 'GET',
    path: '/user-events/:userId',
    summary: 'Get user-events for given user',
    description: 'Retrieves user events for specified user, filterable by category',
    pathParams: GetUserEventPathParamSchema,
    query: GetUserEventQuerySchema,
    responses: {
      200: GetUserEventResponseSchema,
    },
  },

  migrateUserEvents: {
    method: 'POST',
    path: '/migration',
    summary: 'Batch migrate user events from Laravel',
    description: 'Used by migration service to migrate user events from Laravel. Supports dry-run mode. Returns created records with their generated UUIDs.',
    body: MigrateUserEventsRequestSchema,
    responses: {
      200: MigrateUserEventsResponseSchema,
    },
  },

  verifyUserEvents: {
    method: 'POST',
    path: '/migration/verify',
    summary: 'Verify migrated user events',
    description: 'Verifies that user events have been migrated correctly by comparing event count and first/last events against expected values.',
    body: VerifyUserEventsRequestSchema,
    responses: {
      200: VerifyUserEventsResponseSchema,
    },
  },

  deleteMigratedUserEvents: {
    method: 'DELETE',
    path: '/migration',
    summary: 'Delete migrated user events',
    description: 'Deletes user events for specified users. Optionally filter by date range (performedAt). Supports dry-run mode.',
    body: DeleteMigratedUserEventsRequestSchema,
    responses: {
      200: DeleteMigratedUserEventsResponseSchema,
    },
  },
})
